import { createNewUser, getAllUsers, getUserRoles, deleteAUser, updateAUser } from 'api/user';
import { pushAlert, ALERT_TYPES } from 'creatella-react-components/lib/reduxReducers/alerts';

const FETCH_USERS = 'FETCH_USERS';
const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

const FETCH_USER_ROLES = 'FETCH_USER_ROLES';
const FETCH_USER_ROLES_SUCCESS = 'FETCH_USER_ROLES_SUCCESS';
const FETCH_USER_ROLES_FAILURE = 'FETCH_USER_ROLES_FAILURE';

const CREATE_USER = 'CREATE_USER';
const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

const DELETE_USER = 'DELETE_USER';
const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

const UPDATE_USER = 'UPDATE_USER';
const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

const fetchUsers = () => ({
    type: FETCH_USERS
});

const fetchUsersSuccess = (data) => ({
    type: FETCH_USERS_SUCCESS,
    data
});

const fetchUsersFailure = () => ({
    type: FETCH_USERS_FAILURE
});

const fetchUserRoles = () => ({
    type: FETCH_USER_ROLES
});

const fetchUserRolesSuccess = (data) => ({
    type: FETCH_USER_ROLES_SUCCESS,
    data
});

const fetchUserRolesFailure = () => ({
    type: FETCH_USER_ROLES_FAILURE
});

const createUser = () => ({
    type: CREATE_USER
});

const createUserSuccess = (data) => ({
    type: CREATE_USER_SUCCESS,
    data
});

const createUserFailure = () => ({
    type: CREATE_USER_FAILURE
});

const deleteUser = () => ({
    type: DELETE_USER
});

const deleteUserSuccess = (data) => ({
    type: DELETE_USER_SUCCESS,
    data
});

const deleteUserFailure = () => ({
    type: DELETE_USER_FAILURE
});

const updateUser = () => ({
    type: UPDATE_USER
});

const updateUserSuccess = (data) => ({
    type: UPDATE_USER_SUCCESS,
    data
});

const updateUserFailure = () => ({
    type: UPDATE_USER_FAILURE
});

export function handleFetchUsers(query) {
    return async (dispatch) => {
        dispatch(fetchUsers());

        try {
            const { data } = await getAllUsers(query);

            dispatch(fetchUsersSuccess(data));
        } catch (e) {
            dispatch(fetchUsersFailure());
        }
    };
}

export function handleFetchUserRoles() {
    return async (dispatch) => {
        dispatch(fetchUserRoles());

        try {
            const { data: { data } } = await getUserRoles();

            dispatch(fetchUserRolesSuccess(data));
        } catch (e) {
            dispatch(fetchUserRolesFailure());
        }
    };
}

export function handleCreateUser(query) {
    return async (dispatch) => {
        dispatch(createUser());

        try {
            const { data: { data } } = await createNewUser(query);
            console.debug("===== response 1=====")

            console.debug(data)

            console.debug("===== response 1 =====")

            dispatch(createUserSuccess(data));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'User created!'
            }));
            dispatch(handleFetchUsers());
        } catch (e) {
            dispatch(createUserFailure());
            if(e?.status === 422){
                const responseData = e.data;

                if (responseData.errors && responseData.errors.email &&
                    responseData.errors.email.includes("The email has already been taken.")) {
                    // Handle the case where only the email is taken
                    dispatch(pushAlert({
                        type: ALERT_TYPES.ERROR,
                        message: 'Email already in use. Please use a different email address.'
                    }));
                    return
                }
            }
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Creating user failed'
            }));
        }
    };
}

export function handleUpdateUser(id, query) {
    return async (dispatch) => {
        dispatch(updateUser());

        try {
            const { data: { data } } = await updateAUser(id, query);

            dispatch(updateUserSuccess(data));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'User updated!'
            }));
            dispatch(handleFetchUsers());
        } catch (e) {
            dispatch(updateUserFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Updating user failed'
            }));
        }
    };
}

export function handleDeleteUser(userId) {
    return async (dispatch) => {
        dispatch(deleteUser());

        try {
            const data = await deleteAUser(userId);

            dispatch(deleteUserSuccess(data));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'User deleted!'
            }));
            dispatch(handleFetchUsers());
        } catch (e) {
            dispatch(deleteUserFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Deleting user failed'
            }));
        }
    };
}

const INITIAL_STATE = {
    isLoading: true,
    users: [],
    userRoles: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_USERS:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                users: action.data
            };
        case FETCH_USERS_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case FETCH_USER_ROLES:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_USER_ROLES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userRoles: action.data
            };
        case FETCH_USER_ROLES_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case CREATE_USER:
            return {
                ...state,
                isLoading: true
            };
        case CREATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case CREATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case DELETE_USER:
            return {
                ...state,
                isLoading: true
            };
        case DELETE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case DELETE_USER_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case UPDATE_USER:
            return {
                ...state,
                isLoading: true
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case UPDATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        default:
            return {
                ...state
            };
    }
};
